import { IDomainResource } from '../Resource';
import { IBackboneElement } from '../BackboneElement';
import { code } from '../Primitives';
import { ICodeableConcept } from '../CodeableConcept';

export type OperationOutcomeType = 'OperationOutcome';

export const isOperationOutcome = (
  resource: object | null | undefined,
): resource is IOperationOutcome => {
  return (
    !!resource &&
    (resource as IOperationOutcome).resourceType === 'OperationOutcome'
  );
};

export type OperationOutcomeSeverity =
  | 'fatal'
  | 'error'
  | 'warning'
  | 'information';

export interface IOperationOutcomeIssue extends IBackboneElement {
  severity: OperationOutcomeSeverity;
  code: code;
  details?: ICodeableConcept;
  diagnostics?: string;
  location?: string;
  expression?: string;
}

export interface IOperationOutcome
  extends IDomainResource<OperationOutcomeType> {
  issue: Array<IOperationOutcomeIssue>;
}
